import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              热门话题
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              大家都在关注的热点话题标签
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
            {topics.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-4 p-4 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-300 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg text-secondary-600 w-4 h-4 flex items-center justify-center`}></i>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</div>
                  <div className="text-xs text-foreground-400 mt-0.5">{item.count} 讨论</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}